// removed by extract-text-webpack-plugin
module.exports = {"Header":"Toolbar__Header__1Chn3","Toolbar":"Toolbar__Toolbar__2JJW-","Logo":"Toolbar__Logo__1efBD","DesktopOnly":"Toolbar__DesktopOnly__WADUd"};